export default __webpack_public_path__ + "static/zt-4fb7c0dd96c4ff8693fa9a5b450dd213.jpeg";